<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
  [ngStyle]="{'display': 'inline-block', 'width.px': width, 'height.px': height}">
  <use [attr.xlink:href]="'#icon-' + name"></use>
</svg>
